import { createStyles, makeStyles, Theme, space } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      height: `calc(100vh - ${theme.space.headerMobileHeight}px - 16px)`,
    },
  },
  root: {
    maxWidth: space.singleColumnMaxWidth,
    [theme.breakpoints.up('md')]: {
      margin: '0 auto',
      width: '100%',
      marginTop: 24,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
      flex: 1,
    },
  },
  label: {
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16,
    },
  },
  korpoCodeBox: {
    marginTop: 24,
    borderTop: `1px solid ${theme.color.greys[15]}`,
    paddingTop: 24,
  },
  codeLabel: {
    marginBottom: 16,
  },
  disclaimerBox: {
    paddingLeft: 32,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 36,
    },
  },
  disclaimerFormControl: {
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  financialInstitutionInput: {
    maxWidth: 308,
    width:'100%',
    paddingTop: 16,
  },
  korpoCodeInput: {
    maxWidth: 308,
    width:'100%',
  },
  buttonContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
    marginTop: 24,
    borderTop: `1px solid ${theme.color.greys[15]}`,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

}), {name: 'OpenIkeIkzeKorpo'});
